import React from "react";
import { Image, Modal } from "react-bootstrap";
import xclose from "../../assets/icons/x-close.svg";

export default function RemarkHistoryModal({ show, onHide, approvalComments }) {

    const parseComments = (raw) => {
        if (!raw) return [];
        // return raw.split("<br>").filter(Boolean).map((part) => {
        //     const match = part.match(/^([^(]+?)\s+\(([^)]+)\):\s*([^]*)$/);
        //     if (!match) return null;
        //     return { dateTime: match[1].trim(), name: match[2].trim(), body: match[3].trim() };
        // }).filter(Boolean);

        return raw.split("<br>").filter(Boolean).map((part) => {
            const parenStart = part.indexOf("(");
            const parenEnd = part.indexOf(")", parenStart);
            const colonIdx = part.indexOf(":", parenEnd);
            if (parenStart === -1 || parenEnd === -1 || colonIdx === -1) return null;
            return {
                dateTime: part.slice(0, parenStart).trim(),
                name: part.slice(parenStart + 1, parenEnd).trim(),
                body: part.slice(colonIdx + 1).trim()
            };
        }).filter(Boolean);
    };


    const checkUpdates = async (e) => {
        e.preventDefault();
        onHide();
    };


    const entries = parseComments(approvalComments);

    return (
        <Modal show={show} onHide={onHide} size="lg" centered className="remark-history-modal">
            <Modal.Header className="remark-history-modal-header">
                <Modal.Title className="remark-history-modal-title">Remark History</Modal.Title>
                <Image src={xclose} onClick={checkUpdates} ></Image>
            </Modal.Header>
            <Modal.Body className="remark-history-modal-body">
                <div className="remark-history-timeline">
                    {entries.map((entry, idx) => (
                        <div className="remark-history-item" key={idx}>
                            <div className="remark-timeline-dot"></div>
                            {idx < entries.length - 1 && <div className="remark-timeline-line"></div>}
                            <div className="remark-history-content">
                                <span className="remark-history-date">{entry.dateTime}</span>
                                <span className="remark-history-name">{entry.name} {entry.action && `(${entry.action})`}</span>
                                <span className="remark-history-body">{entry.body}</span>
                            </div>
                        </div>
                    ))}
                    {entries.length === 0 && <p style={{ color: "#707070" }}>No history available.</p>}
                </div>
            </Modal.Body>
        </Modal>
    );
}
